export var HighOIEGLType;
(function (HighOIEGLType) {
    HighOIEGLType["HIGHOIGAINER"] = "highOiGainer";
    HighOIEGLType["HIGHOILOSER"] = "highOiLoser";
})(HighOIEGLType || (HighOIEGLType = {}));
